export default "__VITE_ASSET__zWVGPm65__"